class ProductRatingSummary extends HTMLElement {
  connectedCallback() {
    const judgeBadge = this.querySelector('.jdgm-prev-badge');
    const standardRating = Number.parseFloat(this.dataset.standardRating);
    const standardCount = Number.parseInt(this.dataset.standardCount, 10);
    const judgeRating = Number.parseFloat(judgeBadge?.dataset.averageRating);
    const judgeCount = Number.parseInt(judgeBadge?.dataset.numberOfReviews, 10);

    const useStandard = Number.isFinite(standardRating) && standardCount > 0;
    const rating = useStandard ? standardRating : judgeRating;
    const count = useStandard ? standardCount : judgeCount;

    if (!Number.isFinite(rating) || !Number.isFinite(count) || count < 1) {
      const emptyLabel = this.dataset.emptyLabel;
      this.querySelector('[data-rating-stars]').closest('.product-rating-summary__stars').hidden = true;
      this.querySelector('[data-rating-average]').hidden = true;
      this.querySelector('[data-rating-count]').textContent = emptyLabel;
      this.querySelector('a').setAttribute('aria-label', emptyLabel);
      this.hidden = false;
      return;
    }

    const formattedRating = rating.toFixed(1);
    const labelTemplate = count === 1 ? this.dataset.singularLabelTemplate : this.dataset.labelTemplate;
    const label = labelTemplate
      .replace('[rating]', formattedRating)
      .replace('[count]', count.toLocaleString(document.documentElement.lang));

    this.querySelector('.product-rating-summary__stars').hidden = false;
    this.querySelector('[data-rating-average]').hidden = false;
    this.querySelector('[data-rating-average]').textContent = formattedRating;
    this.querySelector('[data-rating-count]').textContent = label.replace(formattedRating, '').trim();
    this.querySelector('[data-rating-stars]').style.width = `${Math.min(100, Math.max(0, rating / 5 * 100))}%`;
    this.querySelector('a').setAttribute('aria-label', label);
    this.hidden = false;
  }
}

if (!customElements.get('product-rating-summary')) {
  customElements.define('product-rating-summary', ProductRatingSummary);
}
